import { SUMMARY_SHEET_NAME } from "../../const/excel.const";
import { addSummaryTitle, addSummaryHeaderRow, addSummaryBodyRow, addSummaryTotalRow, } from "../addSummary";
// 요약 시트 만드는 함수
export function makeSummarySheet(workbook, options) {
    const { summaryTitleOptions, summaryRowsOptions, productClassificationInfo } = options;
    const sheet = workbook.addWorksheet(SUMMARY_SHEET_NAME);
    // 타이틀 추가 - 파이온 일렉트릭(주) 자재(재고 자산) 현황
    addSummaryTitle(sheet, summaryTitleOptions);
    // 헤더 행 추가 - No., 구분, 관리코드, 개수, 소계, 비고
    addSummaryHeaderRow(sheet);
    // 데이터 행 추가 (각 시트의 Q2, R2 참조 수식)
    summaryRowsOptions.forEach((rowData, index) => {
        addSummaryBodyRow(sheet, rowData, productClassificationInfo[index].name);
    });
    // 총합계 행 추가 (SUM 수식)
    addSummaryTotalRow(sheet, summaryRowsOptions.length);
}
